'use client';

import {
  SelectAccountAgeFeature,
  SelectAccountFeature,
} from '@features/items-withdrawal';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { ModalWrapper } from '@/shared/ui';
import { useStore } from '@/store/context';

export const CreateTradeWidget = observer(() => {
  const withdrawalStore = useStore().withdrawal;

  return (
    <ModalWrapper
      close={() => withdrawalStore?.closeCreateTrade()}
      isOpened={!!withdrawalStore?.createTradeOpened}>
      {withdrawalStore?.selectedAccountAge ? (
        <SelectAccountFeature />
      ) : (
        <SelectAccountAgeFeature />
      )}
    </ModalWrapper>
  );
});
